export enum COURSE_TYPE {
  EBOOK = 0,
  LINKEDIN = 1,
}

export default COURSE_TYPE;
